// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========== Dashboard Filters Panel ========== */

.dashboard-filters {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  background: var(--color-wood-800);
  border: 2px solid var(--color-wood-700);
  border-radius: var(--radius-lg);
  padding: var(--space-3) var(--space-4);
  margin-bottom: var(--space-4);
}

/* Horizontal scrollable row of chips */
.filter-chips {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
  align-items: center;
}

/* Visibility + Availability side-by-side row */
.filter-row-double {
  display: flex;
  align-items: center;
  gap: 0;
}

.filter-row-double .filter-chips {
  flex-shrink: 0;
}

/* Vertical divider between double-row groups */
.filter-row-divider {
  width: 1px;
  height: 28px;
  background: var(--color-wood-600);
  flex-shrink: 0;
  margin: 0 var(--space-3);
}

/* Base pill chip */
.filter-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  font-family: var(--font-body);
  line-height: 1.2;
  cursor: pointer;
  white-space: nowrap;
  user-select: none;

  background: var(--color-wood-700);
  border: 2px solid var(--color-wood-600);
  color: var(--color-parchment-200);

  transition: background var(--transition-fast), border-color var(--transition-fast), color var(--transition-fast);
}

/* Neutral active state */
.filter-chip--active {
  background: var(--color-fire-700);
  border-color: var(--color-fire-500);
  color: var(--color-parchment-100);
}

.filter-chip--active:hover {
  background: var(--color-fire-600);
  border-color: var(--color-fire-400);
}

/* Green active (participating / has slots) */
.filter-chip--active-green {
  background: var(--color-success-600, #166534);
  border-color: var(--color-success-500, #22c55e);
  color: var(--color-parchment-100);
}

.filter-chip--active-green:hover {
  background: var(--color-success-500, #22c55e);
  border-color: var(--color-success-400, #4ade80);
}

/* Yellow active (invited / pending) */
.filter-chip--active-yellow {
  background: #92400e;
  border-color: #f59e0b;
  color: var(--color-parchment-100);
}

.filter-chip--active-yellow:hover {
  background: #78350f;
  border-color: #fbbf24;
}

/* Red active (none / full) */
.filter-chip--active-red {
  background: var(--color-danger-700, #7f1d1d);
  border-color: var(--color-danger-500, #ef4444);
  color: var(--color-parchment-100);
}

.filter-chip--active-red:hover {
  background: var(--color-danger-600, #991b1b);
  border-color: var(--color-danger-400, #f87171);
}
`, "",{"version":3,"sources":["webpack://./src/pages/EventsDashboard/DashboardFilters.css"],"names":[],"mappings":"AAAA,kDAAkD;;AAElD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iCAAiC;EACjC,uCAAuC;EACvC,+BAA+B;EAC/B,sCAAsC;EACtC,6BAA6B;AAC/B;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,mBAAmB;EACnB,MAAM;AACR;;AAEA;EACE,cAAc;AAChB;;AAEA,+CAA+C;AAC/C;EACE,UAAU;EACV,YAAY;EACZ,iCAAiC;EACjC,cAAc;EACd,wBAAwB;AAC1B;;AAEA,mBAAmB;AACnB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;;EAEjB,iCAAiC;EACjC,uCAAuC;EACvC,iCAAiC;;EAEjC,gHAAgH;AAClH;;AAEA,yBAAyB;AACzB;EACE,iCAAiC;EACjC,mCAAmC;EACnC,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA,6CAA6C;AAC7C;EACE,6CAA6C;EAC7C,+CAA+C;EAC/C,iCAAiC;AACnC;;AAEA;EACE,6CAA6C;EAC7C,+CAA+C;AACjD;;AAEA,sCAAsC;AACtC;EACE,mBAAmB;EACnB,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,6BAA6B;AAC7B;EACE,4CAA4C;EAC5C,8CAA8C;EAC9C,iCAAiC;AACnC;;AAEA;EACE,4CAA4C;EAC5C,8CAA8C;AAChD","sourcesContent":["/* ========== Dashboard Filters Panel ========== */\n\n.dashboard-filters {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2);\n  background: var(--color-wood-800);\n  border: 2px solid var(--color-wood-700);\n  border-radius: var(--radius-lg);\n  padding: var(--space-3) var(--space-4);\n  margin-bottom: var(--space-4);\n}\n\n/* Horizontal scrollable row of chips */\n.filter-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--space-2);\n  align-items: center;\n}\n\n/* Visibility + Availability side-by-side row */\n.filter-row-double {\n  display: flex;\n  align-items: center;\n  gap: 0;\n}\n\n.filter-row-double .filter-chips {\n  flex-shrink: 0;\n}\n\n/* Vertical divider between double-row groups */\n.filter-row-divider {\n  width: 1px;\n  height: 28px;\n  background: var(--color-wood-600);\n  flex-shrink: 0;\n  margin: 0 var(--space-3);\n}\n\n/* Base pill chip */\n.filter-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: var(--font-body);\n  line-height: 1.2;\n  cursor: pointer;\n  white-space: nowrap;\n  user-select: none;\n\n  background: var(--color-wood-700);\n  border: 2px solid var(--color-wood-600);\n  color: var(--color-parchment-200);\n\n  transition: background var(--transition-fast), border-color var(--transition-fast), color var(--transition-fast);\n}\n\n/* Neutral active state */\n.filter-chip--active {\n  background: var(--color-fire-700);\n  border-color: var(--color-fire-500);\n  color: var(--color-parchment-100);\n}\n\n.filter-chip--active:hover {\n  background: var(--color-fire-600);\n  border-color: var(--color-fire-400);\n}\n\n/* Green active (participating / has slots) */\n.filter-chip--active-green {\n  background: var(--color-success-600, #166534);\n  border-color: var(--color-success-500, #22c55e);\n  color: var(--color-parchment-100);\n}\n\n.filter-chip--active-green:hover {\n  background: var(--color-success-500, #22c55e);\n  border-color: var(--color-success-400, #4ade80);\n}\n\n/* Yellow active (invited / pending) */\n.filter-chip--active-yellow {\n  background: #92400e;\n  border-color: #f59e0b;\n  color: var(--color-parchment-100);\n}\n\n.filter-chip--active-yellow:hover {\n  background: #78350f;\n  border-color: #fbbf24;\n}\n\n/* Red active (none / full) */\n.filter-chip--active-red {\n  background: var(--color-danger-700, #7f1d1d);\n  border-color: var(--color-danger-500, #ef4444);\n  color: var(--color-parchment-100);\n}\n\n.filter-chip--active-red:hover {\n  background: var(--color-danger-600, #991b1b);\n  border-color: var(--color-danger-400, #f87171);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
